import Utils from '@/common/utils/utils';

const getChatAttachmentOrder = file => {
    const order = file?.fileInfo?.order;
    return Number.isInteger(order) ? order : Number.MAX_SAFE_INTEGER;
};

export const getChatAttachmentFiles = (attachFiles, uploadedFilesByPost) => {
    if (!Utils.isEmptyArray(uploadedFilesByPost)) {
        return uploadedFilesByPost;
    }
    if (Utils.isEmptyArray(attachFiles)) return [];
    return [...attachFiles].sort((a, b) => getChatAttachmentOrder(a) - getChatAttachmentOrder(b));
};

/**
 * Remove local uploaded files cache of a post so that attachFiles from server are displayed (ex: after edit msg delete files)
 * @param {*} setUploadedFiles
 * @param {*} postId
 */
export const clearUploadedFilesByPost = (setUploadedFiles, postId) => {
    setUploadedFiles(prev => {
        if (!prev?.[postId]) return prev;
        const { [postId]: removed, ...rest } = prev;
        return rest;
    });
};

export const isChatImageAttachment = file => {
    return Utils.isImageFile(file?.fileInfo?.fileName || file?.fileData?.name);
};
